import React, { useState, createContext } from 'react';
import { Modal, Button } from 'react-bootstrap';
import SearchInputServiceLocations from "../SearchInput/SearchInputServiceLocations"

export const ModalContext = createContext({
  showModal: false,
  openModal: () => {},
  closeModal: () => {}
});

export const LayoutSearchModal = ({ modalTitle }) => {
  return (
    <ModalContext.Consumer>
      {({ showModal, closeModal }) => (
        <Modal show={showModal} onHide={closeModal} fullscreen={
          typeof window !== "undefined" && window?.innerWidth < 576
        }>
          <Modal.Header closeButton>
            <Modal.Title>{modalTitle}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <SearchInputServiceLocations setFocus={(showModal)}/>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={closeModal}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </ModalContext.Consumer>
  );
};

export const ModalController = ({ children }) => {
  const [showModal, setShowModal] = useState(false);

  const openModal = () => {
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  return (
    <ModalContext.Provider value={{ showModal, openModal, closeModal }}>
      {children}
    </ModalContext.Provider>
  );
};
